import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { saveHasManyRelationships } from 'umg-ember-backend/utils/model-save-hooks';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations();

export const settings = {
  saveHooks: {
    after: [saveHasManyRelationships('contributors')],
  },
};

export default class ProductTrackModel extends Model.extend(Validations) {
  @attr() additionalContributors;
  @attr() additionalTrackData;
  @attr('number') duration;
  @attr('boolean') ghosttrack;
  @attr('string') isrc;
  @attr('string') linkedStereoIsrc;
  @attr('string') lyrics;
  @attr('string') mp3;
  @attr('string') mp3Custom;
  @attr('string') mp3Itunes;
  @attr('string') mp3WithFullUrl;
  @attr('string') name;
  @attr('number', { defaultValue: 1 }) number;
  @attr('number') recordingId;
  @attr('boolean') soundFlag;
  @attr('string') versionName;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relation
  @hasMany('product-track-contributor', {
    async: true,
    inverse: 'productTrack',
  })
  contributors;
  @hasMany('product-work', { async: true, inverse: null }) productWorks;
  @belongsTo('product-element', { async: true, inverse: null }) productElement;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return `${this.number}. ${this.name}`;
  }
}
